export default "__VITE_ASSET__CtFI$60$__"